
class BackToTop {
  constructor(){
    const toggle = document.querySelector('.js-backtotop-toggle');
    if(toggle){
      toggle.addEventListener('click', e => {
        window.scrollTo({top: 0, behavior: 'smooth'});
      });
    }
  }
} export default BackToTop;
